import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CONTRACT_STATUS } from 'shared/constants';
import { ContractStatus, CustomerContractInventoryGridItem } from 'shared/types';
import { compareDates } from 'shared/utility';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function ContractStatusColumn(props: UseTableCellProps<CustomerContractInventoryGridItem, ContractStatus>) {
  const {
    value,
    row: {
      original: { endDate },
    },
  } = props;
  const isContractExpired = compareDates(new Date(endDate), new Date()) === 1;
  const displayValue = isContractExpired ? CONTRACT_STATUS['inactive'] : CONTRACT_STATUS[value];
  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{displayValue}</Typography>
    </Box>
  );
}
